import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeChatPage from '../components/HomeChatPage';
import AdminDashboard from '../components/AdminDashboard';
import KnowledgeBase from '../components/KnowledgeBase';
import { IndustryProvider } from '../lib/IndustryContext';
import { LocaleProvider } from '../lib/LocaleContext';
import './App.css';

/** When deployed under IIS at a subpath (e.g. /aichatapp/), Router must use basename so routes match. */
function getBasename() {
  if (typeof window === 'undefined' || !window.location) return '/';
  const p = (window.location.pathname || '/').replace(/\/$/, '') || '/';
  if (p === '') return '/';
  const dir = p.replace(/\/[^/]*$/, '');
  return dir === '' ? p : dir;
}

export default function App() {
  return (
    <LocaleProvider>
      <IndustryProvider>
        <BrowserRouter basename={getBasename()}>
        <Routes>
          <Route path="/" element={<HomeChatPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
        </Routes>
        </BrowserRouter>
      </IndustryProvider>
    </LocaleProvider>
  );
}
